export const listItem = ["listItem1", "listItem2", "listItem3"];

export const tableHeaders = ["Gänge", "„Verbotene“ Kombinationen"];
export const tableRows = [
  { id: "1", styles: { textAlign: "center", width: "50%" }, cells: ["3 x 8", "4 - 2 - 4 oder 3 - 2 - 3"] },
  {
    id: "2",
    styles: { textAlign: "center", width: "50%" },
    cells: ["3 x 7", "3 - 2 - 3 oder 2 - 2 - 2 oder 2 - 0 - 2"],
  },
  { id: "3", styles: { textAlign: "center", width: "50%" }, cells: ["2 x 12 / 2 x 11", "4 - 4"] },
  { id: "4", styles: { textAlign: "center", width: "50%" }, cells: ["2 x 10 - 2 x 8", "3 - 3 oder 2 - 2"] },
  { id: "5", styles: { textAlign: "center", width: "50%" }, cells: ["2 x 7", "1 - 1"] },
  {
    id: "6",
    styles: { textAlign: "center" },
    cells: ["Räder mit nur einem Kettenblatt (z. B. 1 x 11, 1 x 8), oder Fixies / Singlespeeds", "0"],
  },
];

export const dropdwon1Options = ["1", "2", "3"];
export const dropdwon3Options = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"];
export const letters = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m"];

export const fieldsForField4 = [
  "field4a",
  "field4b",
  "field4c",
  "field4d",
  "field4e",
  "field4f",
  "field4g",
  "field4h",
  "field4i",
  "field4j",
  "field4k",
  "field4l",
  "field4m",
];

export const dropdown5options1 = [
  "4 - 4 - 4",
  "4 - 2 - 4",
  "3 - 2 - 3",
  "2 - 2 - 2",
  "2 - 0 - 2",
  "1 - 0 - 1",
  "0 - 0 - 0",
];
export const dropdown5options2 = ["4 - 4", "3 - 3", "2 - 2", "1 - 1", "0 - 0"];

export const commonColors = { green: "#05B709", red: "#FF4200", blue: "#04B0E9", orange: "#e67d5b" };
